import { RefObject, useEffect, useRef } from 'react';
import { CommentIcon, Tooltip, TOOLTIP_SURFACE } from '@repo/atomic-components';
import { classNames as cn } from 'primereact/utils';
import { useFrostedGlassClass } from '@/ui/theme/useFrostedGlassClass';

const LABEL = 'Open the chat box';

type MinimizedChatInputButtonProps = {
  onClick: () => void;
};

/** Shown instead of the input dock when minimised, styled like the collapsed box. */
export const MinimizedChatInputButton = ({ onClick }: MinimizedChatInputButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const frostedBgClass = useFrostedGlassClass();

  /**
   * This only ever mounts because the user just pressed minimise, and that control unmounts with
   * the box - without this, keyboard focus would drop to the body.
   */
  useEffect(() => {
    buttonRef.current?.focus();
  }, []);

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={onClick}
        aria-label={LABEL}
        className={cn(
          'border-theme-border-grey text-theme-text-grey focus-visible:outline-fletchers-green-500 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border p-0 shadow-sm transition-shadow hover:shadow-md',
          frostedBgClass,
        )}
      >
        <CommentIcon width={18} height={18} aria-hidden />
      </button>
      <Tooltip
        target={buttonRef as RefObject<HTMLElement>}
        content={LABEL}
        position="top"
        className={TOOLTIP_SURFACE}
        baseZIndex={10000}
      />
    </>
  );
};
